import { Controller } from "@hotwired/stimulus"
const classes = require("util/classes")(__filename)

export default class extends Controller {
  static targets = ["imageWrapper", "lens"]
  static values = {
    zoomUrl: String,
    zoomFactor: { type: Number, default: 2.5 }
  }

  connect() {
    this.lensVisible = false
  }

  onMouseEnter() {
    if (this.isHoverlessDevice() || !this.zoomUrlValue) return
    this.showLens()
  }

  onMouseMove(event) {
    if (!this.lensVisible) return
    this.positionLens(event)
  }

  onMouseLeave() {
    this.hideLens()
  }

  onClick(event) {
    // Keyboard activation (Enter/Space) fires a click with detail === 0; let those
    // through so keyboard users can reach the zoom modal even on hover-capable devices.
    if (event.detail === 0) return
    // Pointer clicks on hover-capable devices use the lens instead of the modal.
    if (!this.isHoverlessDevice()) {
      event.preventDefault()
    }
  }

  showLens() {
    this.lensTarget.style.backgroundImage = `url(${this.zoomUrlValue})`
    this.lensTarget.classList.add(classes("visible"))
    this.lensVisible = true
  }

  hideLens() {
    this.lensTarget.classList.remove(classes("visible"))
    this.lensVisible = false
  }

  positionLens(event) {
    const rect = this.imageWrapperTarget.getBoundingClientRect()
    if (rect.width === 0 || rect.height === 0) {
      this.hideLens()
      return
    }

    const x = event.clientX - rect.left
    const y = event.clientY - rect.top

    if (x < 0 || x > rect.width || y < 0 || y > rect.height) {
      this.hideLens()
      return
    }

    const lensSize = this.lensTarget.offsetWidth
    const halfLens = lensSize / 2
    const factor = this.zoomFactorValue

    this.lensTarget.style.left = `${x - halfLens}px`
    this.lensTarget.style.top = `${y - halfLens}px`
    this.lensTarget.style.backgroundSize = `${rect.width * factor}px ${rect.height * factor}px`
    this.lensTarget.style.backgroundPosition = `${-x * factor + halfLens}px ${-y * factor + halfLens}px`
  }

  isHoverlessDevice() {
    return window.matchMedia("(hover: none)").matches
  }
}
